
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/hooks/useTheme";
import { LanguageProvider } from "@/hooks/useLanguage";
import Dashboard from "./pages/Dashboard";
import Index from "./pages/Index";
import Leaks from "./pages/Leaks";
import LeakDetails from "./pages/LeakDetails";
import CVE from "./pages/CVE";
import CVEDetail from "./pages/CVEDetail";
import Ransomware from "./pages/Ransomware";
import EOL from "./pages/EOL";
import Releases from "./pages/Releases";
import NotFound from "./pages/NotFound";
import { HackerBackground } from "@/components/layout/HackerBackground";

// Create a new query client with improved caching strategies
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <HackerBackground />
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              {/* Make Dashboard the root page */}
              <Route path="/" element={<Dashboard />} />
              <Route path="/news" element={<Index />} />
              <Route path="/leaks" element={<Leaks />} />
              <Route path="/leaks/:domain" element={<LeakDetails />} />
              <Route path="/CVE" element={<CVE />} />
              <Route path="/CVE/:cveId" element={<CVEDetail />} />
              <Route path="/ransomware/:countryCode?" element={<Ransomware />} />
              <Route path="/ransomware/group/:groupName" element={<Ransomware />} />
              <Route path="/eol" element={<EOL />} />
              <Route path="/eol/:product" element={<EOL />} />
              <Route path="/releases" element={<Releases />} />
              {/* Redirect /dashboard to root for backward compatibility */}
              <Route path="/dashboard" element={<Navigate to="/" replace />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
